import React from "react";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { deleteDocument, setActiveDocument, renameDocument } from "../redux/documentsSlice";

export const DocumentList = ({ searchTerm }: { searchTerm: string }) => {
  const dispatch = useAppDispatch();
  const documents = useAppSelector((state) => state.documents.documents);
  const activeDocumentId = useAppSelector((state) => state.documents.activeDocumentId);

  const filteredDocs = documents.filter((doc) =>
    doc.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="p-2 space-y-2 overflow-y-auto">
      {filteredDocs && filteredDocs.map((doc) => (
        <div
          key={doc.id}
          className={`p-2 border rounded cursor-pointer ${doc.id === activeDocumentId ? "bg-blue-200" : ""}`}
          onClick={() => dispatch(setActiveDocument(doc.id))}
        >
          <div className="w-full flex gap-1 items-start">
            <input
              value={doc.title}
              onChange={(e) => dispatch(renameDocument({ id: doc.id, title: e.target.value }))}
              className="bg-transparent w-full font-semibold cursor-pointer "
            />
            <button
              onClick={(e) => {
                e.stopPropagation();
                dispatch(deleteDocument(doc.id));
              }}
              className="text-red-500 text-xs"
            >
              x
            </button>
          </div>
          <div className="text-red-500 text-xs pt-2">{doc.error}</div>
        </div>
      ))}

      {filteredDocs.length === 0 && <div className="text-gray-400 text-sm">No Document Found</div>}
    </div>
  );
};